import { GroupType } from "./GroupType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity RoleAssignments


export interface RoleAssignment {
    id: ID;

    
    membersGroupId: ID;

    
    roleId: ID;

    
    scopeGroupId?: ID;

    
    createdAt: Date;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            membersGroupId: ID[],
        
    
    

            roleId: ID[],
        
    
    

            scopeGroupId: ID[],
        
    
    scopeGroupIdInclude: boolean,



        membersGroupIdRefs?: ID[],
        roleIdRefs?: ID[],
        scopeGroupIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateRoleAssignment {
    
    membersGroupId: ID;

    
    roleId: ID;

    
    scopeGroupId?: ID;

    
    }



export interface PresentationRoleAssignmentRequest {
    list: ListRequest,
    filter: {
        membersGroupId: ID,
        membersGroupIdOr: boolean,
        roleId: ID,
        roleIdOr: boolean,
        membersGroupIdRefs?: ID[],
        roleIdRefs?: ID[],
        scopeGroupIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryRoleAssignment {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: RoleAssignment): PrimaryRoleAssignment | undefined {
        return entity ? new PrimaryRoleAssignment(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryRoleAssignment {
        return new PrimaryRoleAssignment(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryRoleAssignment {
        let vals = path?.split('/');
        return new PrimaryRoleAssignment(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryRoleAssignment[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: RoleAssignment): string {
    let fields = entity ? [
    entity.membersGroupId,
            entity.roleId,
            ] : [];
    return fields.filter(item => item).join(' | ');
}


